// extracted by mini-css-extract-plugin
module.exports = {"notification":"CustomForm_notification__FMjTQ","notification__content":"CustomForm_notification__content__2mKG2","notification__wrapper":"CustomForm_notification__wrapper__VcOVI"};